import $ from 'jquery';
import AOS from 'aos';
import 'aos/dist/aos.css';

$('body').on('loaded', function() {
  AOS.init({
    duration: 1000,
  });
});
